import axios from 'axios'
import Request from 'src/utils/request'

/**
 * 获取测试签名
 * @returns
 */
export const getOssSignatureApi = () => {
  return Request({
    url: '/system/oss/signature',
    unique: true,
  })
}

// 获取文件后缀名
function getFileSuffix (name) {
  return name.slice(name.lastIndexOf('.') + 1).toLowerCase()
}
// 随机字母，文件名
function getRandomString (len) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let str = ''
  for (let i = 0; i < len; i++) {
    str += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return str
}

// 获取阿里签名
async function getSignature () {
  const signature = await getOssSignatureApi()
  return signature
}

// 文件上传
export async function uploadFile (file) {
  const signature = await getSignature()
  const formData = new FormData()
  const name = getRandomString() + '.' + getFileSuffix(file.name) + ''
  formData.append('key', signature.dir + name)
  formData.append('policy', signature.policy)
  formData.append('OSSAccessKeyId', signature.accessid)
  formData.append('success_action_status', '200')
  formData.append('callback', signature.callback)
  formData.append('signature', signature.signature)
  formData.append('file', file)
  const { data, status } = await axios.post(signature.host, formData, {
    'Content-Type': 'multipart/form-data',
  })
  if (status === 200 && data.status === 'success') {
    return data.data
  } else {
    return Promise.reject(data.message)
  }
}
